import React from 'react';
import { styled } from '@linaria/react';
import { Icon } from '@daedalus/atlas/Icon';
import { StarRating } from '@daedalus/atlas/StarRating';
import { Text } from '@daedalus/atlas/Text';
import { ContentHotel } from '@findhotel/sapi';
interface Props {
  hotel?: ContentHotel;
}
const _exp = /*#__PURE__*/() => Text;
const HotelLocationWrapper = /*#__PURE__*/styled(_exp())({
  name: "HotelLocationWrapper",
  class: "hrasoqu",
  propsAsIs: true
});
export const LocationOverlayHotelInfo: React.FC<Props> = ({
  hotel
}) => {
  if (!hotel) return null;
  return <div>
      <StarRating rating={hotel.starRating} />
      <Text variant="titleL">{hotel.hotelName}</Text>
      <HotelLocationWrapper colorPath="content.neutral.c600" variant="bodyS">
        <Icon size="sm" name="Pin" />
        <span>{hotel.placeDisplayName}</span>
      </HotelLocationWrapper>
    </div>;
};

require("./LocationOverlayHotelInfo.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./LocationOverlayHotelInfo.tsx");